import { PhoneWidgetProviders } from '@revenuewell/widget-phone';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { useProductsByLocation } from 'apps/wrapper/src/hooks/use-products-by-location';
import { PropsWithChildren } from 'react';

export const ConditionalPhoneProviders: React.FC<PropsWithChildren> = ({ children }) => {
  const { selectedLocation } = useLocations();
  const { hasProduct, isLoading: isLoadingProducts } = useProductsByLocation(selectedLocation?.id);
  const enabled = !isLoadingProducts && hasProduct('phone2');

  return enabled ? <PhoneWidgetProviders>{children}</PhoneWidgetProviders> : <>{children}</>;
};
